import React from "react";
import Box from "components/UI/Box";
import Button from "components/UI/Button";
import Input from "components/UI/Input";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL, STRIPE_CLIENT_ID, ERROR_HANDLE } from "config/constants";
import "./style.css";
import Select from "react-select";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";

class Facility extends React.Component {

  state = {
    contact_name: "",
    gym_name: "",
    phone: "",
    email: "",
    password: "",
    url: "",
    address: "",
    rate: "",
    account_name: "",
    account_number: "",
    flexit_cut: "",
    chain_id: "",
    location: "",
    authorization_code: ""
  };

  componentDidMount() {
    this.getChainList();
  }

  change(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  handleChange = address => {
    this.setState({
      address
    });
  };

  handleSelect = address => {
    this.setState({ address });
    geocodeByAddress(address)
      .then(res => {
        this.setState({
          address: res[0].formatted_address
        });
        return getLatLng(res[0])
      })
      .then(position => {
        this.setState({
          location: `${position.lat},${position.lng}`
        });
      })
      .catch(error => {
        console.log("error", error);
      });
  };

  handleError = (status, clearSuggestions) => {
    console.log("Error from Google Maps API", status);
    this.setState({ errorMessage: status }, () => {
      clearSuggestions();
    });
  };

  sendFacility() {
    const toastId = toast("Sending Facility Data...");
    const access_token = localStorage.getItem("access_token");
    const authorization_code = localStorage.getItem("authorization_code");
    let {
      contact_name,
      gym_name,
      phone,
      email,
      password,
      url,
      address,
      rate,
      account_name,
      account_number,
      flexit_cut,
      chain_id,
      location
    } = this.state;

    if (this.state.flexit_cut === "") flexit_cut = "30";

    axios
      .post(
        `${API_URL}/gyms/register`,
        {
          contact_name,
          gym_name,
          phone,
          email,
          password,
          url,
          address,
          rate,
          account_name,
          account_number,
          flexit_cut,
          chain_id,
          location,
          authorization_code
        },
        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        toast.dismiss(toastId);
        toast("Added Successfully", { autoClose: 1500 });
        localStorage.removeItem("authorization_code");
      })
      .catch(err => {
        toast.dismiss(toastId);
        ERROR_HANDLE(err);
      });
  }

  handleLocationChange = ({ position, address }) => {
    const location = `${position.lat},${position.lng}`;
    this.setState({ location });
  };

  getChainList() {
    const access_token = localStorage.getItem("access_token");
    axios
      .get(
        `${API_URL}/admin/chains`,

        {
          headers: {
            "x-access-token": access_token
          }
        }
      )
      .then(res => {
        this.setState({
          ...this.state,
          chains: res.data.map(chain => ({
            value: chain.id,
            label: chain.name
          }))
        });
      })
      .catch(err => {
        ERROR_HANDLE(err);
      });
  }

  selectChain = selectedItem => {
    const chain_id = selectedItem.value;
    if (chain_id) {
      this.setState({ chain_id });
    } else {
      this.setState({ chain_id: "" });
    }
  };

  render() {
    const { address } = this.state;
    const STRIPE_CALLBACK_URL = `${window.location.origin}/stripe`;
    const STRIPE_URL = `https://connect.stripe.com/express/oauth/authorize?redirect_uri=${STRIPE_CALLBACK_URL}&client_id=${STRIPE_CLIENT_ID}&state=1`;

    return (
      <div className="div_FacilitySectionWrapper">
        <p className="p_SectionHeader">Facility</p>
        <Box outline>
          <div className="div_OnboardingFacility_BoxInner">
            <div className="div_OnboardingFacility_Box_Item">
              <Input
                type="text"
                name="gym_name"
                placeholder="Name (Required)"
                onChange={this.change.bind(this)}
              />

              <PlacesAutocomplete
                onChange={this.handleChange}
                value={address}
                onSelect={this.handleSelect}
                onError={this.handleError}
                shouldFetchSuggestions={address.length > 1}
              >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                  <div>
                    <Input
                      {...getInputProps({
                        placeholder: "Address  (Required)"
                      })}
                    />
                    {suggestions.length > 0 && (
                      <div
                        style={{
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                        }}
                      >
                        {suggestions.map(suggestion => (
                          <div
                            {...getSuggestionItemProps(suggestion)}
                            style={
                              suggestion.active
                                ? {
                                  backgroundColor: "var(--primary)",
                                  padding: "16px 15px",
                                  transition: "padding .1s",
                                  color: "white"
                                }
                                : {
                                  padding: "5px 10px",
                                  transition: "padding .1s"
                                }
                            }
                          >
                            <strong>
                              {suggestion.formattedSuggestion.mainText}
                            </strong>{" "}
                            <small>
                              {suggestion.formattedSuggestion.secondaryText}
                            </small>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </PlacesAutocomplete>
              <Input
                type="text"
                name="phone"
                placeholder="Phone  (Required)"
                onChange={this.change.bind(this)}
              />
              <Input
                type="text"
                name="email"
                placeholder="Email  (Required)"
                onChange={this.change.bind(this)}
              />
              <Input
                type="password"
                name="password"
                placeholder="password  (Required)"
                onChange={this.change.bind(this)}
              />
              <Input
                type="text"
                name="url"
                placeholder="Website URL"
                onChange={this.change.bind(this)}
              />
              <Input
                type="text"
                name="rate"
                placeholder="Price/min  (Required)"
                onChange={this.change.bind(this)}
              />
              <Input
                type="text"
                name="contact_name"
                placeholder="Contact Name"
                onChange={this.change.bind(this)}
              />
              <br />
            </div>
            <div className="div_OnboardingFacility_Box_Item">
              {/* <p className="p_OnboardingFacilityFormHeader">Bank Details </p>
              <Input
                type="text"
                name="account_name"
                placeholder="Account Name"
                onChange={this.change.bind(this)}
              />
              <Input
                type="text"
                name="account_number"
                placeholder="Account Number"
                onChange={this.change.bind(this)}
              /> */}

              <p className="p_OnboardingFacilityFormHeader">
                Flexit Percentage
              </p>
              <Input
                type="text"
                name="flexit_cut"
                placeholder="30%"
                onChange={this.change.bind(this)}
              />
              {/* <Input
                type="text"
                name="chain_name"
                placeholder="Enter chain name"
                onChange={this.change.bind(this)}
              /> */}
              <br />
              <br />

              <Select
                placeholder="Enter Chain Name"
                options={this.state.chains}
                isMulti={false}
                onChange={this.selectChain}
              />
              <br />
              <a href={STRIPE_URL} class="stripe-connect" target="_blank">
                <span>Connect with Stripe</span>
              </a>
            </div>
          </div>
          <div className="div_ActionButtonContainer_OnboardinLanding">
            <div className="div_Button_OnboardLanding_small">
              <Button type="primary" onClick={this.sendFacility.bind(this)}>
                Send
              </Button>
            </div>
          </div>
        </Box>
      </div>
    );
  }
}

export default Facility;
